import { gql } from "@apollo/client";

const Fragments = {
  individualPartner: gql`
    fragment individualPartner on IndividualPartner {
      partnerId
      partnerTypeId
      uniqueId
      fullName
      citizenship
      nationality
      idSeriesAndNumber
      birthDate
      country
      county
      city
    }
  `,
  legalPartner: gql`
    fragment legalPartner on LegalPartner {
      partnerId
      partnerTypeId
      uniqueId
      name
      legalForm
    }
  `
};

export default Fragments;
